export declare const navigator: { connection: any };
// TODO: move this to preload service strategy
export class NetworkFunctions {
  static hasGoodConnection(): boolean {
    const conn = navigator.connection;
    if (conn) {
      if (conn.saveData) {
        // console.log(`Not Preloading since Save Data is Enabled`);
        return false; // save data mode is enabled, so don't preload
      }
      const avoidTheseConnections = ['slow-2g', '2g' /* , '3g', '4g' */];
      const effectiveType = conn.effectiveType || '';
      if (avoidTheseConnections.includes(effectiveType)) {
        // console.log(`Not Preloading since Network Type = ${effectiveType}`);
        return false;
      }
    }
    return true;
  }
}
